import {Component} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {LanguageService} from "../classes/language.service";

@Component({
  selector: 'app-language-select-page',
  standalone: true,
  imports: [
    MatButtonModule
  ],
  templateUrl: './language-select-page.component.html',
  styleUrl: './language-select-page.component.scss'
})
export class LanguageSelectPageComponent {

  constructor(private languageService: LanguageService) {

  }

  changeLanguage(lang: string) {
    this.languageService.currentLang$.next(lang);
  }
}
